module.exports = __webpack_public_path__ + "img/join2.f5432b1e.png";